import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import classNames from 'classnames'

import ProductImage from '../../product-image'
import ProductSummary from '../../product-summary'

import analyticsUtils from '../../../../helpers/analytics-utils'
import style from './index.scss'
import generateTag from './generate-tag'

const ProductCard = ({
  src,
  retailer,
  productName,
  price,
  salePrice,
  link,
  className,
  id,
  primaryCategory,
  brand,
  position,
  retailerCode,
  list,
}) => {
  const productClick = () => {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.PRODUCTS_CLICK,
      ecommerce: {
        click: {
          actionField: { list },
          products: [
            {
              name: productName,
              id,
              category: primaryCategory,
              brand,
              position,
              price: (salePrice || price) / 100,
              dimension79: retailerCode,
              dimension87: retailer,
            },
          ],
        },
      },
    })
  }
  return (
    <div className={classNames(style.productCard, className)}>
      <Link to={link} onClick={productClick}>
        <ProductImage
          src={src}
          tag={generateTag(price, salePrice)}
          className={style.productImage}
          loadingClassName={style.productImageloading}
          alt={''}
        />
        <ProductSummary
          compact
          title={retailer}
          productName={productName}
          price={price}
          salePrice={salePrice}
          classNames={{ container: style.productSummaryContainer }}
        />
      </Link>
    </div>
  )
}

ProductCard.propTypes = {
  src: PropTypes.string.isRequired,
  retailer: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  salePrice: PropTypes.number,
  link: PropTypes.string.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  primaryCategory: PropTypes.string,
  brand: PropTypes.string,
  position: PropTypes.number,
  retailerCode: PropTypes.string,
  list: PropTypes.string.isRequired,
}

export default ProductCard
